import React from 'react';
import ReactDOM from 'react-dom/client';
import SoftSellMarketplace from '../softsell-marketplace.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <SoftSellMarketplace />
  </React.StrictMode>
);
